import { render, staticRenderFns } from "./MaterialCalendar.vue?vue&type=template&id=11b3bf8f&scoped=true&"
import script from "./MaterialCalendar.vue?vue&type=script&lang=js&"
export * from "./MaterialCalendar.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCalendar.vue?vue&type=style&index=0&id=11b3bf8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b3bf8f",
  null
  
)

export default component.exports